import React from "react";
import { Module } from "../../components";
import { BusinessInsurance } from "./Pages/BusinessInsurance";
import { BusinessMultiRisk } from "./Pages/BusinessMultiRisk";
import { BusinessLottery } from "./Pages/BusinessLottery";
import { BusinessHealthInsurance } from "./Pages/BusinessHealthInsurance";
import { BusinessHealthResults } from "./Pages/BusinessHealthResults";

const Empresarial = () => {
  return (
    <Module moduleName="Caixa Seguradora">
      <Module.Page
        path="/seguro-facil-empresarial-empreendedor"
        title="Seguro Fácil Empresarial Empreendedor"
        page={BusinessInsurance}
        description="Segurança financeira acessível para a sua empresa"
      />
      <Module.Page
        path="/seguro-multirisco-empresarial"
        title="Seguro Multirrisco Empreendedor"
        page={BusinessMultiRisk}
        description="Seguro Multirrisco Empresarial, garantimos a segurança do seu negócio em várias situações inesperadas."
      />
      <Module.Page
        path="/seguro-empresarial-loterico-e-cca"
        title="Seguro Empresarial Lotérico e CCA"
        page={BusinessLottery}
        description="Seguro Empresarial Lotérico e CCA, a segurança do seu negócio está garantida."
      />
      <Module.Page
        path="/seguro-saude-empresarial"
        title="Seguro Saúde Empresarial"
        page={BusinessHealthInsurance}
        description="Seguro Sáude Empresarial"
      />
      <Module.Page
        path="/seguro-saude/resultados"
        title="Programa de Qualificação de Operadoras - PQO"
        page={BusinessHealthResults}
        description="Seguro Saúde Empresarial Programa de Qualificação de Operadoras - PQO"
      />
    </Module>
  );
};

Empresarial.propTypes = {};

export default Empresarial;
